import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

interface CookieConsentProps {
  onAccept: () => void;
  onDecline: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
    onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
    onDecline();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h3 className="cookie-consent-title">We Value Your Privacy</h3>
          <p className="cookie-consent-text">
            We use cookies and analytics tools to improve your experience and understand how you interact with our website.
            By accepting, you agree to our use of Google Analytics for tracking website usage.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="cookie-consent-btn cookie-consent-btn-decline"
            onClick={handleDecline}
            aria-label="Decline cookies"
          >
            Decline
          </button>
          <button
            className="cookie-consent-btn cookie-consent-btn-accept"
            onClick={handleAccept}
            aria-label="Accept cookies"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
